module.exports = __webpack_public_path__ + "img/CF.e5bac49e.png";